import { Injectable } from "@angular/core";
import {
  Actions,
  createEffect,
  EffectNotification,
  ofType,
  OnRunEffects
} from "@ngrx/effects";
import { Observable } from "rxjs";
import { exhaustMap, map, takeUntil } from "rxjs/operators";
import { RoomLiveStreamStatusEvents } from "../events";
import { RoomService } from "../services";

@Injectable()
export class RoomLiveStreamStatusEventsEffects implements OnRunEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly roomService: RoomService
  ) {}

  listenRoomLiveStreamStatusUpdate$ = createEffect(() =>
    this.roomService.listenRoomLiveStreamStatusUpdate().pipe(
      map((_) =>
        RoomLiveStreamStatusEvents.update({
          roomId: _.value.id,
          status: _.value.status
        })
      )
    )
  );

  ngrxOnRunEffects(resolvedEffects$: Observable<EffectNotification>) {
    return this.actions$.pipe(
      ofType(RoomLiveStreamStatusEvents.init),
      exhaustMap(() =>
        resolvedEffects$.pipe(
          takeUntil(
            this.actions$.pipe(ofType(RoomLiveStreamStatusEvents.destroy))
          )
        )
      )
    );
  }
}
